import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';

import { useStore } from '@feathr/extender/state';

import { skeleton } from '@feathr/components/dist/style/skeleton.css';

interface IProps {
  className?: string;
  id: string;
}

function CustomFieldLabel({ className, id }: Readonly<IProps>): JSX.Element {
  const { CustomFields } = useStore();
  const customField = CustomFields.get(id);
  return (
    <div className={classNames({ [skeleton]: customField.isPending }, className)}>
      {customField.name}
    </div>
  );
}

export default observer(CustomFieldLabel);
